// extracted by mini-css-extract-plugin
export default {"container":"styles_container__i5Rly","headerContainer":"styles_headerContainer__JhSXX"};